import React from 'react';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

import theme from './BreakTabs.scss';

import { CardTab, CardTabs } from 'common/components/core/tabs';
const breaksTabsFactory = ({ BreakTab }) => {
    class BreakTabs extends React.PureComponent {
        render() {
            const {
                theme,
                allBreaks,
                currentDate,
                unappliedBreaks,
                activeBreakKey,
                breakTypeList,
                getBreakKey,
                deleteBreak,
                addBreak,
                handleFieldFocus,
                onBreakValueChange,
                activeTabIndex,
                onTabChange,
                homebases,
                breakSlotFor,
                shiftStart,
                shiftEnd,
                endDayOffset,
                t
            } = this.props;
            return (
                <CardTabs
                    index={activeTabIndex}
                    theme={theme}
                    onChange={onTabChange}
                >
                    {breakTypeList.map((breakType, breakTabIndex) => {
                        const breaks = allBreaks[breakType.toLowerCase()];
                        return (
                            <CardTab
                                theme={theme}
                                activeClassName={theme.active}
                                key={breakTabIndex}
                                active={breakTabIndex === 0}
                                label={t('breakType', { type: breakType })}
                            >
                                <BreakTab
                                    handleFieldFocus={handleFieldFocus}
                                    currentDate={currentDate}
                                    breakType={breakType}
                                    breaks={breaks}
                                    unappliedBreaks={unappliedBreaks}
                                    activeBreakKey={activeBreakKey}
                                    getBreakKey={getBreakKey}
                                    deleteBreak={deleteBreak}
                                    addBreak={addBreak}
                                    onBreakValueChange={onBreakValueChange}
                                    homebases={homebases}
                                    theme={theme}
                                    breakSlotFor={breakSlotFor}
                                    shiftStart={shiftStart}
                                    shiftEnd={shiftEnd}
                                    endDayOffset={endDayOffset}
                                />
                            </CardTab>
                        );
                    })}
                </CardTabs>
            );
        }
    }
    return compose(
        themr('BreakTabs', theme),
        translate('configure')
    )(BreakTabs);
};
export { breaksTabsFactory };
export default breaksTabsFactory;
